"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['vừa xong', 'một lúc'],
        ['%s giây trước', 'trong %s giây'],
        ['1 phút trước', 'trong 1 phút'],
        ['%s phút trước', 'trong %s phút'],
        ['1 giờ trước', 'trong 1 giờ'],
        ['%s giờ trước', 'trong %s giờ'],
        ['1 ngày trước', 'trong 1 ngày'],
        ['%s ngày trước', 'trong %s ngày'],
        ['1 tuần trước', 'trong 1 tuần'],
        ['%s tuần trước', 'trong %s tuần'],
        ['1 tháng trước', 'trong 1 tháng'],
        ['%s tháng trước', 'trong %s tháng'],
        ['1 năm trước', 'trong 1 năm'],
        ['%s năm trước', 'trong %s năm'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=vi.js.map